module.exports = __webpack_public_path__ + "media/application/images/2020/redesign2020-header-menu-close-fc8855596a7aa9abad3c9cda387f53ed.svg";